"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var Observable_1 = require("rxjs/Observable");
var HttpDocumentTokenGeneratorService = /** @class */ (function () {
    function HttpDocumentTokenGeneratorService(applicationPropertiesService, httpWrapper) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.httpWrapper = httpWrapper;
    }
    HttpDocumentTokenGeneratorService_1 = HttpDocumentTokenGeneratorService;
    HttpDocumentTokenGeneratorService.prototype.getJWTToken = function (categorySystemName, id, documentSystemName) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categorySystemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(documentSystemName);
        var placeHolders = new Map()
            .set("{category}", categorySystemName)
            .set("{id}", id.toString())
            .set("{systemName}", documentSystemName);
        return this.getUserServiceUrl(HttpDocumentTokenGeneratorService_1.GET_USER_DOCUMENT_TOKEN, placeHolders).flatMap(function (url) {
            return _this.httpWrapper.get(url, { responseType: 'text' })
                .catch(HttpDocumentTokenGeneratorService_1.handleError);
        });
    };
    HttpDocumentTokenGeneratorService.prototype.getUploadDocumentJWTToken = function (categorySystemName, id, documentSystemName) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categorySystemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(id);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(documentSystemName);
        var placeHolders = new Map()
            .set("{category}", categorySystemName)
            .set("{id}", id.toString())
            .set("{systemName}", documentSystemName);
        return this.getUserServiceUrl(HttpDocumentTokenGeneratorService_1.GET_USER_DOCUMENT_UPLOAD_TOKEN, placeHolders).flatMap(function (url) {
            return _this.httpWrapper.get(url, { responseType: 'text' })
                .catch(HttpDocumentTokenGeneratorService_1.handleError);
        });
    };
    HttpDocumentTokenGeneratorService.prototype.getUserServiceUrl = function (extension, placeHolders) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(HttpDocumentTokenGeneratorService_1.UM_SERVICE_URL_KEY)
            .then(function (userServiceBase) { return userServiceBase + HttpDocumentTokenGeneratorService_1.USER_SERVICE_BASE_PATH + extension; })
            .then(function (url) { return _this.replacePlaceholders(url, placeHolders); }))
            .catch(HttpDocumentTokenGeneratorService_1.handleError);
    };
    HttpDocumentTokenGeneratorService.prototype.replacePlaceholders = function (url, placeHolders) {
        return url.replace(/{\w+}/g, function (all) {
            return placeHolders.get(all) || all;
        });
    };
    HttpDocumentTokenGeneratorService.handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error);
    };
    HttpDocumentTokenGeneratorService.UM_SERVICE_URL_KEY = "um-service-url";
    HttpDocumentTokenGeneratorService.USER_SERVICE_BASE_PATH = "/users";
    HttpDocumentTokenGeneratorService.GET_USER_DOCUMENT_TOKEN = "/token/{category}/{id}/{systemName}";
    HttpDocumentTokenGeneratorService.GET_USER_DOCUMENT_UPLOAD_TOKEN = "/token/{category}/{id}/{systemName}/upload";
    HttpDocumentTokenGeneratorService = HttpDocumentTokenGeneratorService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], HttpDocumentTokenGeneratorService);
    return HttpDocumentTokenGeneratorService;
    var HttpDocumentTokenGeneratorService_1;
}());
exports.HttpDocumentTokenGeneratorService = HttpDocumentTokenGeneratorService;
//# sourceMappingURL=http-document-token-generator.service.js.map